<sbb-page-layout>
  <h1>{{ 'app.view.error-view.error' | translate}}</h1>
  <p>{{ error | async }}</p>
</sbb-page-layout>
